'use strict';

const Backbone = require('backbone');

export default Backbone.Model.extend({});
